
const init = () => {
    const marqueeList = document.querySelectorAll('.section-hero__track-box')
    if (!marqueeList.length){
        return;      
    }

    marqueeList.forEach(marquee => {
        const marqueeContent = marquee.querySelector('.section-hero__track');

        const marqueeContentClone = marqueeContent.cloneNode(true);
        marquee.append(marqueeContentClone);
    
        const height = parseInt( window.getComputedStyle(marqueeContent).getPropertyValue("height"),10);
        gsap.utils.toArray(marquee.children).forEach(child => {
            gsap.to(
                child,
                { 
                    y:`+=${height}`,
                    duration: 25,
                    ease: "none",
                    repeat: -1
                }
            )
        })
    })

    const roadList = document.querySelectorAll('.section-hero__road-box')
    if (!roadList.length){
        return;      
    }

    roadList.forEach(road => {
        const roadContent = road.querySelector('.section-hero__road-track');

        const roadContentClone = roadContent.cloneNode(true);
        road.append(roadContentClone);
    
        const height = parseInt( window.getComputedStyle(roadContent).getPropertyValue("height"),10);
        gsap.utils.toArray(road.children).forEach(child => {
            gsap.to(
                child,
                { 
                    y:`+=${height}`,
                    duration: .3,
                    ease: "none",
                    repeat: -1
                }
            )
        })
    })
   
}

document.addEventListener('DOMContentLoaded',init);